module.exports = __webpack_public_path__ + "static/media/3.8456de5c.jpg";